module.exports = __webpack_public_path__ + "img/face-astonished.1e3db783.svg";